import { Button } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

const CancelButton = ({ handleCancel, disabled, buttonText = "Cancel", sx }) => {
  return (
    <Button
      sx={{
        color: HNSColors.secondary[500],
        border: `1px solid ${HNSColors.secondary[500]}`,
        "&:hover": {
          background: HNSColors.secondary[900],
          border: `1px solid ${HNSColors.secondary[500]}`,
        },
        ...sx,
      }}
      onClick={handleCancel}
      className="px-8 py-2 text-sm font-normal leading-none text-center normal-case transition bg-white rounded-full"
      variant="outlined"
      disableElevation
      disabled={disabled}
    >
      {buttonText}
    </Button>
  );
};

export default CancelButton;
